import React, { useState } from "react";

/**
 * Developer tool to map X/Y coordinates on the Zemuria map.
 * Activated via ?devMap=1 URL parameter.
 */
export default function MapCoordLogger() {
  const [lastCoord, setLastCoord] = useState(null);

  const handleClick = (e) => {
    const rect = e.target.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    
    // Format for easy pasting into data.js
    const coordStr = `mapCoords: { x: ${x.toFixed(2)}, y: ${y.toFixed(2)} },`;
    console.log("Logged Coord:", coordStr);
    
    // Copy to clipboard
    navigator.clipboard.writeText(coordStr).then(() => {
        setLastCoord({ x, y });
        alert(`Copied to clipboard:\n${coordStr}`);
    }).catch(err => {
        console.error("Clipboard copy failed:", err);
        setLastCoord({ x, y });
        alert(`Coord: ${coordStr}\n(Copy failed, see console)`);
    });
  };

  const containerStyle = {
    position: "fixed",
    inset: 0,
    zIndex: 9999,
    background: "#111",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    color: "#fff",
    fontFamily: "monospace"
  };

  const mapWrapperStyle = {
    position: "relative",
    display: "inline-block",
    boxShadow: "0 0 20px rgba(0,0,0,0.5)",
    border: "1px solid #444",
    marginTop: "20px"
  };

  const closeBtnStyle = {
    position: "fixed",
    top: 20,
    right: 20,
    zIndex: 10000,
    padding: "10px 20px",
    background: "#cc0000",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontWeight: "bold"
  };

  return (
    <div style={containerStyle}>
      <button 
        onClick={() => window.location.href = window.location.origin + window.location.pathname} 
        style={closeBtnStyle}
      >
        EXIT LOGGER
      </button>
      
      <div style={{ textAlign: "center", maxWidth: "600px" }}>
        <h2 style={{ margin: "0 0 10px 0" }}>Zemuria Map Coordinate Logger</h2>
        <p>Click anywhere on the map to copy percentage-based <code>mapCoords</code> to your clipboard.</p>
        {lastCoord && (
          <div style={{ background: "#222", padding: "10px", borderRadius: "4px", border: "1px solid #555" }}>
            Last Click: x: {lastCoord.x.toFixed(2)}, y: {lastCoord.y.toFixed(2)}
          </div>
        )}
      </div>

      <div style={mapWrapperStyle}>
        <img 
          src="/images/nations/zemuria.webp" 
          alt="Zemuria Map Logger" 
          onClick={handleClick}
          style={{ cursor: "crosshair", display: "block", maxWidth: "90vw" }}
        />
        {lastCoord && (
          <div style={{
            position: "absolute",
            left: `${lastCoord.x}%`,
            top: `${lastCoord.y}%`,
            width: 14,
            height: 14,
            background: "red",
            border: "2px solid white",
            borderRadius: "50%",
            transform: "translate(-50%, -50%)",
            pointerEvents: "none",
            boxShadow: "0 0 5px rgba(0,0,0,0.8)"
          }} />
        )}
      </div>
    </div>
  );
}
